/* eslint-disable yoda */
import React, { useEffect, useState } from 'react';

import { Spinner } from '@ps-design-system/components/Spinner';

import UploaderHeaderWeb from './web/UploaderHeaderWeb';
import UploaderHeaderMobile from './mobile/UploaderHeaderMobile';
import UploaderBottomNavigationWeb from './web/UploaderBottomNavigationWeb';
import UploaderBottomNavigationMobile from './mobile/UploaderBottomNavigationMobile';
import UploaderMediaModal from './UploaderMediaModal';
import UploaderTips from './UploaderTips';
import UploaderDeleteModal from './UploaderDeleteModal';
import UploaderEmptyState from './UploaderEmptyState';
import UploaderMedia from './UploaderMedia';

import { useUploaderPageData } from '../context/UploaderPageContext';
import useUploaderStore from '../store/useUploaderStore';
import { useUploaderActions } from '../hooks/useUploaderActions';

const UploaderLayout = () => {
  const [loading, setLoading] = useState(true);
  const { isMobile } = useUploaderPageData();
  const { fetchMedia } = useUploaderActions();
  const media = useUploaderStore((state) => state.media);
  const setMedia = useUploaderStore((state) => state.setMedia);

  useEffect(() => {
    const loadMedia = async () => {
      setLoading(true);
      try {
        const fetchedMedia = await fetchMedia();
        setMedia(fetchedMedia);
      } catch {
        setMedia([]);
      } finally {
        setLoading(false);
      }
    };
    loadMedia();
  }, [fetchMedia, setMedia]);

  return (
    <div className='uploader-layout'>
      <UploaderMediaModal />
      <UploaderTips />
      <UploaderDeleteModal />
      {!isMobile ? <UploaderHeaderWeb /> : <UploaderHeaderMobile />}
      {loading && <div className='spinner'><Spinner size="large" appearance="black" /></div>}
      {!loading && media.length > 0 && <UploaderMedia />}
      {!loading && media.length === 0 && <UploaderEmptyState />}
      {!isMobile ? <UploaderBottomNavigationWeb /> : <UploaderBottomNavigationMobile />}
    </div>
  );
};

export default UploaderLayout;
